import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import { useForm } from "react-hook-form";

const InoviceModal = ({ close, data }) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    return (
        <div className="relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className="text-center text-[#77498F]">
                پرداخت فاکتور و انتشار
            </h3>
            <div className="flex flex-col justify-center items-start mt-[8rem] mb-[16rem]">
                <div className="flex flex-row gap-48">
                    <span className="text-3xl mb-16 font-bold">
                        نام بوت کمپ:
                    </span>
                    <p className="text-3xl mb-16">{data?.bootcamp_name} </p>
                </div>
                <div className="flex flex-row gap-36">
                    <p className="text-3xl font-bold">مبلغ قابل پرداخت:</p>
                    <p className="text-3xl">1,500,000 تومان</p>
                </div>
            </div>
            <div className="flex justify-end gap-7">
                <BtnAlternative
                    className="py-[2rem] px-[7rem]"
                    text="داشبورد دوره"
                    onClick={() => close(false)}
                />
                <BtnPrimary
                    className="py-[2rem] px-[7rem]"
                    text="پرداخت و انتشار"
                    onClick={() => close(false)}
                />
            </div>
        </div>
    );
};

export default InoviceModal;
